import React, { useEffect, useState } from 'react';
import "./Slots.scss"

const Slots = ({ slots = [], type }) => {

	return (
		<div className={"slots" + (type ? " "+type : '')}>
			{slots.map((el) => {
				return(
					<div className='slots__item' key={el}><span>{el}</span></div>
				)
			})}
		</div>
	);
};

export default Slots;
